import type { DragEvent, ReactElement, ReactNode } from 'react';
import { useState } from 'react';

import { DragDropWrapperStyled } from './styles/DragDropWrapperStyled'
import { DragOverlay } from '../DragOverlay'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'

export interface IDragDropWrapperProps {
  /**
   * Unique identifier for analytics tracking of drag-drop interactions.
   */
  analyticsId?: string
  disabled?: boolean
  onDrop: (files: FileList) => void
  children: ReactElement
  content?: ReactNode
  hideIcon?: boolean
}

export const DragDropWrapper = ({
  analyticsId,
  onDrop,
  content: overlayText,
  children,
  disabled = false,
  hideIcon = false,
}: IDragDropWrapperProps) => {
  const [showOverlay, setShowOverlay] = useState<boolean>(false)

  const onDropHandler = (e: DragEvent) => {
    if (disabled) return

    e.preventDefault()
    setShowOverlay(false)
    onDrop(e.dataTransfer.files)
  }

  const onDragOverHandler = (e: DragEvent) => {
    if (disabled) return

    e.preventDefault()
    setShowOverlay(true)
  }

  const onDragLeaveHandler = (e: DragEvent) => {
    if (disabled) return

    e.preventDefault()
    setShowOverlay(false)
  }

  const analyticsProps = getAnalyticsDataAttrs(analyticsId)

  return (
    <DragDropWrapperStyled
      {...analyticsProps}
      onDrop={onDropHandler}
      onDragOver={onDragOverHandler}
      onDragLeave={onDragLeaveHandler}
    >
      {showOverlay && <DragOverlay content={overlayText} hideIcon={hideIcon} />}
      {children}
    </DragDropWrapperStyled>
  )
}
